
import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { IImportSnapshotsModel } from './OperationsModel';
import JoeyLoading from '../../components/shared/JoeyLoading.vue';

@Component({
    components: {
        JoeyLoading
    }
})
export default class OperationsDashboard extends Vue {
    private importSnapshotsModel: IImportSnapshotsModel = null;
    private isCalculating: boolean = false;
    private sending: boolean = false;
    private disableSendButton: boolean = false;

    created() {
        this.initImportSnapshots();
    }

    public async importSnapshots() {
        if (this.importSnapshotsModel.file) {
            try {
                let formData = new FormData();
                formData.append('uploadSnapshots', this.importSnapshotsModel.file);
                let url = this.$store.state.root._links.operations_import.href;
                url = `${url}?clearDatabase=${!!this.importSnapshotsModel.clearDatabase}`;
                await axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.$snotify.success(`Import successful`);
                this.initImportSnapshots();
            } catch {
                this.$snotify.error(`Could not import data. Try again or contact ICT Support.`);
            }
        } else {
            this.importSnapshotsModel.submitted = true;
        }
    }

    public async calculateEvolutionData() {
        this.isCalculating = true;
        try {
            let url = this.$store.state.root._links.operations_calculate_evolution.href;
            await axios.post(url);
            this.$snotify.success(`Evolution data calculated successfully`);
        } catch {
            // swallow. calculating evolution data could take a while. heroku will cancel the request after 30 seconds
        } finally {
            this.isCalculating = false;
        }
    }

    private handleFilePicked(event: Event) {
        this.importSnapshotsModel.file = (event.target as any).files[0];
    }

    private initImportSnapshots() {
        this.importSnapshotsModel = {
            clearDatabase: false,
            file: undefined,
            submitted: false
        };
    }

    public async sendReminder() {
        this.sending = true;
        let url = this.$store.state.root._links.operations_reminder.href;
        try {
            await axios.post(url);
            this.$snotify.success('Reminders sent succesfully');
            this.disableSendButton = true;
        } catch (e) {
            this.$snotify.error(`Could send the reminders. Try again or contact ICT Support.`);
            this.disableSendButton = false;
        }
        this.sending = false;
    }

    private disableSend(): boolean {
        return this.sending || this.disableSendButton;
    }
}
